import type { Template } from "@/types";

export const LA_02_H0_V2: Template[] = [
{
    id: "LA-02-h0v2-01",
    name: "LA 01 - H0V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-02-h0_v2_01.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 166, y: 39, width: 304, height: 399, rotation: 0, imageRotation: 0 },
            { id: "2", x: 804, y: 39, width: 304, height: 399, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "LA-02-h0v2-02",
    name: "LA 02 - H0V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-02-h0_v2_02.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 166, y: 39, width: 304, height: 399, rotation: 0, imageRotation: 0 },
            { id: "2", x: 773, y: 0, width: 367, height: 476, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "LA-02-h0v2-03",
    name: "LA 03 - H0V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-02-h0_v2_03.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 804, y: 39, width: 304, height: 399, rotation: 0, imageRotation: 0 },
            { id: "2", x: 135, y: 0, width: 367, height: 476, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "LA-02-h0v2-04",
    name: "LA 04 - H0V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-02-h0_v2_04.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 135, y: 0, width: 367, height: 476, rotation: 0, imageRotation: 0 },
            { id: "2", x: 773, y: 0, width: 367, height: 476, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "LA-02-h0v2-05",
    name: "LA 05 - H0V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-02-h0_v2_05.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 135, y: 0, width: 367, height: 476, rotation: 0, imageRotation: 0 },
            { id: "2", x: 908, y: 0, width: 367, height: 476, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "LA-02-h0v2-06",
    name: "LA 06 - H0V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-02-h0_v2_06.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 773, y: 0, width: 367, height: 476, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 0, width: 367, height: 476, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "LA-02-h0v2-07",
    name: "LA 07 - H0V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-02-h0_v2_07.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 0, width: 367, height: 476, rotation: 0, imageRotation: 0 },
            { id: "2", x: 908, y: 0, width: 367, height: 476, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "LA-02-h0v2-08",
    name: "LA 08 - H0V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-02-h0_v2_08.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 162, y: 35, width: 313, height: 405, rotation: 0, imageRotation: 0 },
            { id: "2", x: 864, y: 119, width: 182, height: 237, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "LA-02-h0v2-09",
    name: "LA 09 - H0V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-02-h0_v2_09.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 799, y: 35, width: 313, height: 405, rotation: 0, imageRotation: 0 },
            { id: "2", x: 227, y: 119, width: 182, height: 237, rotation: 0, imageRotation: 0 }
    ],
}
];